import { useEffect, useState } from "react";
import api from "@/lib/api";
import ListingCard from "@/components/ListingCard";

const DEEP = "#1E40AF";

export default function FreePage() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/free-listings", { params: { limit: 200 } }).then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, []);

  return (
    <div className="min-h-[calc(100vh-4rem)] bg-slate-50">
      <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6">
        <h1 className="mb-5 flex items-center gap-2 font-heading text-2xl font-bold text-slate-900" data-testid="free-page-heading">
          <i className="ti ti-gift" style={{ fontSize: "22px", color: DEEP }} />
          Free Items — just pay delivery
        </h1>
        {items === null ? (
          <div className="grid grid-cols-3 gap-3 lg:grid-cols-5">
            {Array.from({ length: 10 }).map((_, i) => <div key={i} className="aspect-[4/3] animate-pulse rounded-2xl bg-slate-100" />)}
          </div>
        ) : items.length === 0 ? (
          <div data-testid="free-empty-state" className="rounded-2xl border border-dashed border-slate-300 py-20 text-center text-slate-500">No free items right now — check back soon</div>
        ) : (
          <div className="grid grid-cols-3 gap-3 lg:grid-cols-5" data-testid="free-grid">
            {items.map((l, i) => <ListingCard key={l.id} listing={l} index={i} compact />)}
          </div>
        )}
      </div>
    </div>
  );
}
